/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Stuck_Drift_PlainInputs */

const vi_einvoice_stuck_drift_plain = /** @type {(inputs: Einvoice_Stuck_Drift_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng đơn khác tiền hàng + VAT trên hóa đơn. Báo quản trị để sửa tổng tiền.`)
};

/**

* @param {Einvoice_Stuck_Drift_PlainInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stuck_drift_plain = /** @type {((inputs?: Einvoice_Stuck_Drift_PlainInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Stuck_Drift_PlainInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stuck_drift_plain(inputs)
});